import { ReactNode } from 'react';
import { Link, matchPath, useLocation } from 'react-router-dom';
import t from 'react-translate';
import { Tab as TabType } from 'athena/components/responsive-tabs';
import ProgramSetup from './program-setup';
import Recruitment from './recruitment';
import ProgramProfileSetup from './program-profile-setup';
import MatchingSettings from './matching-settings';
import FeedbackSettings from './feedback-settings';
import Guidance from './guidance';
import ProgramWrapUp from './program-wrap-up';
import { config } from '@config/pendo.config.json';


export type Tab = TabType & {
  allowed: boolean;
  renderContent: () => ReactNode;
  path: string;
};

export const getTabsConfig = (isAdmin: boolean): Tab[] => [
  {
    id: 'program',
    path: '/settings/program-setup',
    allowed: isAdmin,
    renderContent: () => <ProgramSetup />,
    renderContainer: (props) => <Link to='/settings/program-setup' {...props} />,
    text: t.MENTORING_PROGRAMS.SETTINGS.TABS.PROGRAM_SETUP.TITLE(),
    dataQa: config.pendo.athena.mentorshipProgram.settings.tabs.programSetup,
  }, {
    id: 'recruitment',
    path: '/settings/recruitment',
    allowed: isAdmin,
    renderContent: () => <Recruitment />,
    renderContainer: (props) => <Link to='/settings/recruitment' {...props} />,
    text: t.MENTORING_PROGRAMS.SETTINGS.TABS.RECRUITMENT.TITLE(),
    // dataQa: config.pendo.athena.mentorshipProgram.settings.tabs.recruitment,
  }, {
    id: 'profile',
    path: '/settings/profile-setup',
    allowed: isAdmin,
    renderContent: () => <ProgramProfileSetup />,
    renderContainer: (props) => <Link to='/settings/profile-setup' {...props} />,
    text: t.MENTORING_PROGRAMS.SETTINGS.TABS.PROGRAM_PROFILE_SETUP.TITLE(),
    dataQa: config.pendo.athena.mentorshipProgram.settings.tabs.programProfileSetup,
  }, {
    id: 'matching',
    path: '/settings/matching',
    allowed: isAdmin,
    renderContent: () => <MatchingSettings />,
    renderContainer: (props) => <Link to='/settings/matching' {...props} />,
    text: t.MENTORING_PROGRAMS.SETTINGS.TABS.MATCHING_SETTINGS.MATCHING_TITLE(),
    dataQa: config.pendo.athena.mentorshipProgram.settings.tabs.matchingSettings,
  }, {
    id: 'guidance',
    path: '/settings/guidance',
    allowed: isAdmin,
    renderContent: () => <Guidance />,
    renderContainer: (props) => <Link to='/settings/guidance' {...props} />,
    text: t.MENTORING_PROGRAMS.SETTINGS.TABS.GUIDANCE.TITLE(),
    dataQa: config.pendo.athena.mentorshipProgram.settings.tabs.guidance,
  }, {
    id: 'feedback',
    path: '/settings/feedback',
    allowed: isAdmin,
    renderContent: () => <FeedbackSettings />,
    renderContainer: (props) => <Link to='/settings/feedback' {...props} />,
    text: t.MENTORING_PROGRAMS.SETTINGS.TABS.FEEDBACK_SETTINGS.TITLE(),
    dataQa: config.pendo.athena.mentorshipProgram.settings.tabs.feedbackSettings,
  }, {
    id: 'wrap-up',
    path: '/settings/program-wrap-up',
    allowed: isAdmin,
    renderContent: () => <ProgramWrapUp />,
    renderContainer: (props) => <Link to='/settings/program-wrap-up' {...props} />,
    text: t.MENTORING_PROGRAMS.SETTINGS.TABS.PROGRAM_WRAP_UP.TITLE(),
    dataQa: config.pendo.athena.mentorshipProgram.settings.tabs.programWrapUp,
  },
];
